import React from 'react'
import classNames from 'classnames'
import _ from 'lodash'
import immutable from 'immutable'

import {RelatedAccommodation} from './relatedaccommodation.component'
import {RelatedActivity} from './relatedactivity.component'
import {RelatedDestination} from './relateddestination.component'

export class RelatedContentResults extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            showMore: false
        }

        // TODO: Customize header and load items from results with correct type
        _.bindAll(this,
            'getContent',
            'showMore'
        )
    }	

    // shouldComponentUpdate(nextProps, nextState){
    //   if(nextProps.results !== this.props.results || this.state.showMore !== nextState.showMore){
    //     return true
    //   }else{
    //     return false
    //   }
    // }


    getContent() {
        let items = this.props.results.map((item, index)=>{    
            let showMe = this.state.showMore
            if (index < 3 || this.props.count === 9) {
                showMe = true
            }
            let _item = new immutable.fromJS(item)

            switch (this.props.model) {
                case 'accommodation':
                    return <RelatedAccommodation key={index} {...this.props} item={_item} showMe={showMe}/>
                case 'attraction':
                    return <RelatedActivity key={index} {...this.props} item={_item} showMe={showMe}/>
                case 'destination':
                    return <RelatedDestination key={index} {...this.props} item={_item} showMe={showMe}/>
            }
        })
        return <div className="related-content-items">{ items }</div>
    }

    showMore() {
        if (this.props.showMore) {
            this.props.showMore()
        } else {
            this.setState({showMore: true})
        }    
    }



    render() {
        let title = ''
        let place = ''
        if (this.props.type === 'regional') {
            title = 'Popular destinations in ' + this.props.region
        } else {
            if (this.props.item) {
                place = this.props.item.get('name') ? this.props.item.get('name') : this.props.item.get('title')
            } else {
                place = 'here'
            }
            switch (this.props.type) {
                case 'nearby':
                    switch (this.props.model) {
                        case 'accommodation':
                            title = 'Accommodations near ' + place
                            break
                        case 'attraction':
                            title = 'Activities near ' + place
                            break
                        case 'destination':
                            title = 'Destinations near ' + place
                            break
                    }
                    break
                default:
                    switch (this.props.model) {
                        case 'accommodation':
                            title = 'Similar Accommodations to ' + place
                            break
                        case 'attraction':
                            title = 'Similar Activities to ' + place
                            break
                        case 'destination':
                            title = 'Similar Destinations to' + place
                            break
                    }
                    break
            }
        }

        let showMoreBtn = this.props.results.length > 3 && !this.state.showMore ? <div className="btn btn-plain" onClick={() => { this.showMore() }}>Show More</div> : ''

        return (
            <div className="related-content-band">
                <h3>{ title }</h3>
                { this.getContent() }
                {showMoreBtn}
            </div>
        )
    }
}